import React from "react";
import { BadgeCheck, Check, Gift, LockKeyhole, ShieldCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "./Button";
import { offerItems } from "../data/offer";
const PRODUCT_IMAGE_URL = "https://cdn.magicpatterns.com/uploads/hmVM8txqysKpPWQXeC4oe2/MOCK_UP_SIN_FONDO.png";
const trustItems = [{
  label: "Compra segura",
  icon: ShieldCheck
}, {
  label: "Satisfacción garantizada",
  icon: BadgeCheck
}, {
  label: "Privacidad protegida",
  icon: LockKeyhole
}];
export function OfferSection() {
  const shouldReduceMotion = Boolean(useReducedMotion());
  const handlePurchase = () => {
    window.dispatchEvent(new CustomEvent("checkout:open"));
  };
  return <section id="card" aria-labelledby="offer-heading" className="relative isolate w-full scroll-mt-4 overflow-hidden bg-[#090B0D] py-20 text-[#F4F1EB] sm:py-24 lg:py-28" data-id="element-127" data-mp="wbya28iab2j8">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-24 -z-10 h-[700px] w-[95%] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(242,184,75,0.085),transparent_68%)]" data-id="element-128" data-mp="2y3uj9bgzc0au" />

      <div className="mx-auto max-w-[1120px] px-4 sm:px-8 lg:px-12" data-id="element-129" data-mp="xwjru7bo4njd">
        <header className="text-center" data-id="element-130" data-mp="sxp1mkbdfwp8">
          <div className="flex items-center justify-center gap-3" data-id="element-131" data-mp="syqlnead7tj3">
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/60" data-id="element-132" data-mp="owdk722nihs4" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#F2B84B] sm:text-xs" data-id="element-133" data-mp="oual7sjiteb9">
              OFERTA COMPLETA
            </p>
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/60" data-id="element-134" data-mp="1gock1ziwy4q1" />
          </div>
          <h2 id="offer-heading" className="mt-5 text-[2.5rem] font-extrabold leading-none tracking-[-0.045em] text-[#F4F1EB] sm:text-[3.5rem] lg:text-[4.5rem]" data-id="element-135" data-mp="1ckn05nd6obbc">
            MEGA OFERTA
          </h2>
        </header>

        <motion.div initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.08
      }} transition={{
        duration: 0.65,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mt-10 overflow-hidden rounded-[28px] border border-[#2E343C] bg-[#11161B] p-5 shadow-[0_35px_100px_rgba(0,0,0,0.42),0_0_45px_rgba(242,184,75,0.045)] sm:p-8 lg:mt-14 lg:p-12" data-id="element-136" data-mp="18432dgdui7b">
          <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-[radial-gradient(circle_at_top,rgba(242,184,75,0.11),transparent_70%)]" data-id="element-137" data-mp="3otlm0wg03est" />

          <div className="relative mx-auto flex max-w-[720px] items-center justify-center" data-id="element-138" data-mp="3fuhy9f5w2b7z">
            <img src={PRODUCT_IMAGE_URL} alt="Biblioteca profesional Recursos Fitness Pro con más de 1.000 GIFs de musculación" className="h-auto w-full object-contain drop-shadow-[0_30px_45px_rgba(0,0,0,0.48)]" loading="lazy" decoding="async" data-id="element-139" data-mp="315u51fjimdl7" />
          </div>

          <div className="mx-auto mt-7 max-w-[860px] sm:mt-10" data-id="element-140" data-mp="2s70277flcqz7">
            <ul aria-label="Contenido incluido" className="divide-y divide-[#2E343C]/80" data-id="element-141" data-mp="2x2fg1zdlmmvm">
              {offerItems.map(item => {
              const Icon = item.kind === "bonus" ? Gift : Check;
              return <li key={item.text} className="flex gap-3 py-3.5 text-sm leading-6 text-[#F4F1EB] sm:gap-4 sm:py-4 sm:text-base" data-id="element-142" data-mp="28kezv9odoseu">
                    <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${item.kind === "bonus" ? "border-[#D98A24]/45 bg-[#D98A24]/10 text-[#F2B84B]" : "border-[#F2B84B]/35 bg-[#F2B84B]/10 text-[#F2B84B]"}`} data-id="element-143" data-mp="2mgae327u1fbw">
                      <Icon aria-hidden="true" className="h-3.5 w-3.5 stroke-[2.4]" data-id="element-144" data-mp="2rgojsdlyod6r" />
                    </span>
                    <span className={item.kind === "bonus" ? "font-semibold" : undefined} data-id="element-145" data-mp="3662xtz0hfish">
                      {item.text}
                    </span>
                  </li>;
            })}
            </ul>

            <div className="mt-8 rounded-[20px] border border-[#2E343C] bg-[#161C22] p-5 sm:p-6" data-id="element-146" data-mp="3f7tyuqk2v1g0">
              <dl className="space-y-4 text-sm sm:text-base" data-id="element-147" data-mp="3a9skgixljqav">
                <div className="flex items-start justify-between gap-5 border-b border-[#2E343C] pb-4" data-id="element-148" data-mp="18jtp5aapux1g">
                  <dt className="text-[#B8BDC3]" data-id="element-149" data-mp="1dhboc8yxlxw9">Biblioteca profesional +1.000 GIFs</dt>
                  <dd className="shrink-0 font-mono font-semibold text-[#F4F1EB]" data-id="element-150" data-mp="1i8bn7jrm2q1e">$49.900</dd>
                </div>
                <div className="flex items-start justify-between gap-5" data-id="element-151" data-mp="1m9dlnydpey2b">
                  <dt className="text-[#B8BDC3]" data-id="element-152" data-mp="pkfrah9v925o">4 Bonos exclusivos</dt>
                  <dd className="text-right font-semibold text-[#F2B84B]" data-id="element-153" data-mp="pmir1t0tm9nl">
                    Incluidos sin costo extra
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-9 text-center" data-id="element-154" data-mp="yn76ms5v4i2l">
              <p className="text-sm font-medium text-[#B8BDC3] sm:text-base" data-id="element-155" data-mp="13l0a3dfs6xz6">
                De{" "}
                <span className="font-mono text-[#8F969D] line-through decoration-[#D98A24]/80 decoration-2" data-id="element-156" data-mp="29yzmeq9q5lcf">
                  $49.900
                </span>{" "}
                por solo
              </p>
              <div className="mt-2 font-mono text-[3.25rem] font-extrabold leading-none tracking-[-0.065em] text-[#F2B84B] drop-shadow-[0_0_24px_rgba(242,184,75,0.14)] sm:text-[4.75rem]" data-id="element-157" data-mp="2p1pvvpta5uzq">
                $14.900
              </div>
              <p className="mt-5 text-xs tracking-[0.04em] text-[#B8BDC3] sm:text-sm" data-id="element-158" data-mp="2fb4xo3hiqshc">
                Pago único · Acceso inmediato · Sin mensualidades
              </p>
            </div>

            <motion.div className="relative mx-auto mt-8 w-full max-w-[590px] rounded-full" whileHover={shouldReduceMotion ? undefined : {
            scale: 1.015,
            y: -2
          }} whileTap={shouldReduceMotion ? undefined : {
            scale: 0.985,
            y: 0
          }} transition={{
            duration: 0.25,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-159" data-mp="26duqat7tnnhp">
              <span aria-hidden="true" className="pointer-events-none absolute -inset-2 rounded-full border border-[#F2B84B]/25 shadow-[0_0_28px_rgba(242,184,75,0.2)]" data-id="element-160" data-mp="3qrv0rdqnb46q" />
              <Button type="button" size="lg" onClick={handlePurchase} className="relative h-16 w-full rounded-full border border-[#F8D788]/70 bg-[#F2B84B] px-6 text-sm font-extrabold tracking-[0.015em] text-[#101010] shadow-[0_12px_32px_rgba(217,138,36,0.28),inset_0_1px_0_rgba(255,255,255,0.42)] transition-[background-color,box-shadow] duration-[250ms] hover:bg-[#F6C667] hover:shadow-[0_16px_38px_rgba(217,138,36,0.36),0_0_32px_rgba(242,184,75,0.22),inset_0_1px_0_rgba(255,255,255,0.46)] focus-visible:ring-[#F2B84B]/60 sm:text-base" data-id="element-161" data-mp="1k3w3rs2anzm5">
                QUIERO COMPRAR AHORA →
              </Button>
            </motion.div>

            <ul aria-label="Garantías de compra" className="mt-7 grid grid-cols-3 overflow-hidden rounded-2xl border border-[#2E343C] bg-[#0E1317]" data-id="element-162" data-mp="1ttfj4nqstbc9">
              {trustItems.map(({
              label,
              icon: Icon
            }, index) => <li key={label} className={`flex flex-col items-center justify-center gap-2 px-2 py-4 text-center text-[10px] leading-4 text-[#B8BDC3] sm:flex-row sm:px-4 sm:text-xs ${index > 0 ? "border-l border-[#2E343C]" : ""}`} data-id="element-163" data-mp="ndvg5wdnvp6f" data-mpi={index}>
                  <Icon aria-hidden="true" className="h-5 w-5 shrink-0 text-[#F2B84B]" data-id="element-164" data-mp="au7w0dc662fn" />
                  <span data-id="element-165" data-mp="ovaksxujtqu9">{label}</span>
                </li>)}
            </ul>

            <aside aria-label="Garantía incondicional de 7 días" className="relative mt-7 flex items-center gap-4 overflow-hidden rounded-[18px] border border-[#F2B84B]/20 bg-[#141A1F] px-4 py-4 text-left shadow-[0_16px_44px_rgba(0,0,0,0.24),inset_0_1px_0_rgba(255,255,255,0.025)] sm:gap-5 sm:px-5 sm:py-5" data-id="element-166" data-mp="jvxws9rxydq3">
              <div aria-hidden="true" className="pointer-events-none absolute -left-10 top-1/2 h-28 w-28 -translate-y-1/2 rounded-full bg-[#F2B84B]/[0.055] blur-2xl" data-id="element-167" data-mp="5wy6yysozssc" />
              <div className="relative flex h-[62px] w-[62px] shrink-0 items-center justify-center rounded-full border border-[#F8D788]/70 bg-[#F2B84B] text-center text-[#101010] shadow-[0_0_0_5px_rgba(242,184,75,0.09),0_8px_22px_rgba(217,138,36,0.22)] sm:h-[68px] sm:w-[68px]" data-id="element-168" data-mp="39jf4bj145po1">
                <span className="text-[10px] font-black uppercase leading-[0.88] tracking-[-0.03em] sm:text-[11px]" data-id="element-169" data-mp="2o2q2c4ruolpe">
                  7<br data-id="element-170" data-mp="2szq8sgsm3qh1" />
                  <span className="text-[12px] sm:text-[13px]" data-id="element-171" data-mp="2t3dyt5yulur0">DÍAS</span>
                </span>
              </div>
              <p className="relative min-w-0 text-[12px] leading-5 text-[#B8BDC3] min-[390px]:text-[13px] sm:text-[15px] sm:leading-6" data-id="element-172" data-mp="321zf0ugukxom">
                <strong className="font-bold text-[#F4F1EB]" data-id="element-173" data-mp="36zhs8x1wdz2f">
                  Garantía incondicional de 7 días.
                </strong>{" "}
                Si no es para ti, te devolvemos el 100% de tu dinero. El riesgo es totalmente nuestro.
              </p>
            </aside>
          </div>
        </motion.div>
      </div>
    </section>;
}